import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';

import { FiltersComponent } from '../../../common/filters.component';
import { Data2Service } from '../../../common/data2.service';

@Component({
	selector: 'app-tourism-schedules-filters',
	templateUrl: './tourism-schedules-filters.component.html',
	styleUrls: ['./tourism-schedules-filters.component.css'],
})
export class TourismSchedulesFiltersComponent extends FiltersComponent {
	filters = {
		name: null,
		departureFromFirstStop_from: null,
		departureFromFirstStop_to: null,
		status: {},
		owner: {},
	};
	// @Input('statuses') statuses: Array<any>;
	// @Input('users') users: Array<any>;

	protected filtersAfterLoad() {
		// let changed: boolean = false;
		// if (!this.filters.departureFromFirstStop_from) {
		// 	this.filters.departureFromFirstStop_from = new Date().toISOString().split('T')[0];
		// 	changed = true;
		// }
		// if (!this.filters.departureFromFirstStop_to) {
		// 	let date = new Date();
		// 	date.setDate(date.getDate() + 30);
		// 	this.filters.departureFromFirstStop_to = date.toISOString().split('T')[0];
		// 	changed = true;
		// }
		// if (changed) {
		// 	this.filtersSave();
		// }
	}
}
